import { stringifyWithBooleanConversion } from './create-param-values';

export const filterRequestUrlByRegex = (url: string, templateUrl: string) => {
  let urlRegex = templateUrl.replace(/{{URL_PARAMS_GRD}}/g, '(.*)$');
  urlRegex = urlRegex.replace(/{{URL_PARAMS_\d+}}/g, '(.*?)');
  const regex = new RegExp(urlRegex);
  return regex.test(url);
};

export const filterRequestBodyByRegex = (body: string, templateBody: string) => {
  let modifiedTemplateBody: any;
  try {
    modifiedTemplateBody = stringifyWithBooleanConversion(JSON.parse(templateBody));
  } catch (error) {
    modifiedTemplateBody = templateBody;
  }

  let bodyRegex = modifiedTemplateBody.replace(/{{REQ_BODY_GRD_\d+}}/g, '(.*)$');
  bodyRegex = bodyRegex.replace(/{{REQ_BODY_\d+}}/g, '(.*?)');
  const regex = new RegExp(bodyRegex);
  return regex.test(body);
};

export const filterResponseBodyByRegex = (body: string, responseMatch: string) => {
  let modifiedResponseMatch: any;

  try {
    modifiedResponseMatch = JSON.parse(responseMatch);
  } catch (error) {
    modifiedResponseMatch = responseMatch;
  }

  const responseRegex = modifiedResponseMatch.replace(/{{\w+}}/g, '(.*?)');
  const regex = new RegExp(responseRegex);

  return regex.test(body);
};

export const sortByContentType = (array: any) => {
  return array.sort((a: any, b: any) => {
    // First, sort by content type
    if (
      a.contentType?.includes('application/json') &&
      !b.contentType?.includes('application/json')
    ) {
      return -1;
    }

    if (
      !a.contentType?.includes('application/json') &&
      b.contentType?.includes('application/json')
    ) {
      return 1;
    }

    // If content types are the same, sort by countId in descending order
    if (a.countId !== undefined && b.countId !== undefined) {
      return b.countId - a.countId;
    }

    // If countId is not available for comparison, maintain original order
    return 0;
  });
};

export const sortByCountId = (array: any) => {
  return array.sort((a: any, b: any) => {
    if (a.countId !== undefined && b.countId !== undefined) {
      return b.countId - a.countId;
    }

    return 0;
  });
};
